import Chart from "./Chart.jsx";

const ExpensesChart=(props)=>{

    const dataPoints=[
        {   // 0
            label: "Jan",
            value: 0
        },
        {   // 1
            label: "Feb",
            value: 0
        },
        {   // 2
            label: "Mar",
            value: 0
        },
        {   // 3
            label: "Apr",
            value: 0
        },
        {   // 4
            label: "May",
            value: 0
        },
        {   // 5
            label: "Jun",
            value: 0
        },
        {   // 6
            label: "Jul",
            value: 0
        },
        {   // 7
            label: "Aug",
            value: 0
        },
        {   // 8
            label: "Sep",
            value: 0
        },
        {   // 9
            label: "Oct",
            value: 0
        },
        {   // 10
            label: "Nov",
            value: 0
        },
        {   // 11
            label: "Dec",
            value: 0
        },
    ];

    for(let expense of props.expenses){
        let expensemonth=expense.date.getMonth(); // gets Month index between 0 and 11.
        dataPoints[expensemonth].value+=+expense.price; // adding the values to that month
        //           also can be done by parseInt(expense.price)
    }

    return (
        <Chart dataPoints={dataPoints}/>
    );
}

export default ExpensesChart;